import { render } from "./ScrollTop.vue?vue&type=template&id=88a412e0&ts=true"
import script from "./ScrollTop.vue?vue&type=script&lang=ts"
export * from "./ScrollTop.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__